import { render } from "./candidates_formation_tab.vue?vue&type=template&id=1b9f0d56"
import script from "./candidates_formation_tab.vue?vue&type=script&lang=js"
export * from "./candidates_formation_tab.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__